import AffixFooter from './affix-footer'

AffixFooter.install = Vue => Vue.component(AffixFooter.name, AffixFooter)

export default AffixFooter
